export default "__VITE_ASSET__Dc$6nEwr__"